const MODULE_NAME = 'fulcrum/container/Project/CpmSection'

const FETCH_CPM_DETAILS = MODULE_NAME + '/FETCH_CPM_DETAILS'
const FETCH_CPM_DETAILS_START = MODULE_NAME + '/FETCH_CPM_DETAILS_START'
const FETCH_CPM_DETAILS_SUCCESS = MODULE_NAME + '/FETCH_CPM_DETAILS_SUCCESS'
const FETCH_CPM_DETAILS_ERROR = MODULE_NAME + '/FETCH_CPM_DETAILS_ERROR'

const FETCH_CPM_DETAILS_SELECTION = MODULE_NAME + '/FETCH_CPM_DETAILS_SELECTION'
const FETCH_CPM_DETAILS_SELECTION_START = MODULE_NAME + '/FETCH_CPM_DETAILS_SELECTION_START'
const FETCH_CPM_DETAILS_SELECTION_SUCCESS = MODULE_NAME + '/FETCH_CPM_DETAILS_SELECTION_SUCCESS'
const FETCH_CPM_DETAILS_SELECTION_ERROR = MODULE_NAME + '/FETCH_CPM_DETAILS_SELECTION_ERROR'

const POST_CPM_DETAILS = MODULE_NAME + '/POST_CPM_DETAILS'
const POST_CPM_DETAILS_START = MODULE_NAME + '/POST_CPM_DETAILS_START'
const POST_CPM_DETAILS_SUCCESS = MODULE_NAME + '/POST_CPM_DETAILS_SUCCESS'
const POST_CPM_DETAILS_ERROR = MODULE_NAME + '/POST_CPM_DETAILS_ERROR'

const UPDATE_CPM_DETAILS_CHANGE = MODULE_NAME + '/UPDATE_CPM_DETAILS_CHANGE'
const RESET_CPM_DETAILS_CHANGE = MODULE_NAME + '/RESET_CPM_DETAILS_CHANGE'

const UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER = MODULE_NAME + '/UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER'
const UPDATE_PROJECT_PRIORITY_ID = MODULE_NAME + '/UPDATE_PROJECT_PRIORITY_ID'
const UPDATE_PRODUCT_SAMPLED_ID = MODULE_NAME + '/UPDATE_PRODUCT_SAMPLED_ID'
const UPDATE_READY_FOR_REVIEW_ID = MODULE_NAME + '/UPDATE_READY_FOR_REVIEW_ID'
const UPDATE_PUBLISH_TO_WEB_ID = MODULE_NAME + '/UPDATE_PUBLISH_TO_WEB_ID'
const UPDATE_CPM_NOTES = MODULE_NAME + '/UPDATE_CPM_NOTES'
const UPDATE_PROD_RELEASE = MODULE_NAME + '/UPDATE_PROD_RELEASE'
const UPDATE_GENERAL_AVAILABILITY = MODULE_NAME + '/UPDATE_GENERAL_AVAILABILITY'

const SPEC_ORDER = [
  'nineHundredLevelPartNumber',
  'projectPriority',
  'productSampled',
  'readyForReview',
  'publishToWeb',
  'cpmNotes',
  'generalAvailability',
  'prodRelease'
]

export {
  MODULE_NAME,
  FETCH_CPM_DETAILS,
  FETCH_CPM_DETAILS_START,
  FETCH_CPM_DETAILS_SUCCESS,
  FETCH_CPM_DETAILS_ERROR,
  FETCH_CPM_DETAILS_SELECTION,
  FETCH_CPM_DETAILS_SELECTION_START,
  FETCH_CPM_DETAILS_SELECTION_SUCCESS,
  FETCH_CPM_DETAILS_SELECTION_ERROR,
  POST_CPM_DETAILS,
  POST_CPM_DETAILS_START,
  POST_CPM_DETAILS_SUCCESS,
  POST_CPM_DETAILS_ERROR,
  UPDATE_CPM_DETAILS_CHANGE,
  RESET_CPM_DETAILS_CHANGE,
  UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER,
  UPDATE_PROJECT_PRIORITY_ID,
  UPDATE_PRODUCT_SAMPLED_ID,
  UPDATE_READY_FOR_REVIEW_ID,
  UPDATE_PUBLISH_TO_WEB_ID,
  UPDATE_CPM_NOTES,
  UPDATE_GENERAL_AVAILABILITY,
  UPDATE_PROD_RELEASE,
  SPEC_ORDER
}
